/**
 * PSTV — Vuori-style product page
 * 1. Destroy Flickity so it stops fighting CSS grid
 * 2. Scroll-then-stick product info
 * 3. Open first accordion by default
 */
(function() {
  if (!document.querySelector('.product-section')) return;

  /* --- 1. Destroy Flickity on desktop --- */
  function destroyFlickity() {
    if (window.innerWidth < 769) return;

    var slideshow = document.querySelector('.product-section .product-slideshow');
    if (!slideshow) return;

    /* Flickity stores its instance on the element */
    var flkty = slideshow.flickity
      || (window.Flickity && Flickity.data(slideshow))
      || null;

    if (flkty && typeof flkty.destroy === 'function') {
      flkty.destroy();
    }

    /* Force all slides visible (belt + suspenders with CSS) */
    var slides = slideshow.querySelectorAll('.product-main-slide');
    slides.forEach(function(slide) {
      slide.style.position = 'static';
      slide.style.transform = 'none';
      slide.style.left = 'auto';
      slide.style.opacity = '1';
      slide.style.visibility = 'visible';
      slide.removeAttribute('aria-hidden');
    });

    var viewport = slideshow.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = 'auto';
      viewport.style.overflow = 'visible';
      viewport.style.position = 'static';
    }

    var slider = slideshow.querySelector('.flickity-slider');
    if (slider) {
      slider.style.position = 'static';
      slider.style.transform = 'none';
    }
  }

  /* --- 2. Sticky product info --- */
  function initStickyProductInfo() {
    if (window.innerWidth < 769) return;

    var meta = document.querySelector('.product-section .product-single__meta');
    if (!meta) return;

    /* Kill Impulse's own sticky calc (it sets crazy top values) */
    function calcSticky() {
      var metaHeight = meta.offsetHeight;
      var headerEl = document.querySelector('.site-header');
      var announcementEl = document.querySelector('.announcement-bar');
      var headerHeight = 0;
      if (headerEl) headerHeight += headerEl.offsetHeight;
      if (announcementEl) headerHeight += announcementEl.offsetHeight;

      var viewportHeight = window.innerHeight;
      var gap = 20; /* breathing room */

      if (metaHeight <= viewportHeight - headerHeight - gap) {
        /* Info fits in viewport — stick at top under header */
        meta.style.position = 'sticky';
        meta.style.top = (headerHeight + gap) + 'px';
      } else {
        /* Info is taller than viewport — stick so bottom
           of info aligns with bottom of viewport.
           This means: top = viewport - metaHeight - gap */
        var stickyTop = viewportHeight - metaHeight - gap;
        meta.style.position = 'sticky';
        meta.style.top = stickyTop + 'px';
      }
    }

    calcSticky();

    /* Recalc on resize */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        /* On mobile, remove sticky */
        if (window.innerWidth < 769) {
          meta.style.position = '';
          meta.style.top = '';
          return;
        }
        calcSticky();
      }, 150);
    });

    /* Recalc if content changes (variant switches, accordions, etc.) */
    var observer = new MutationObserver(function() {
      setTimeout(calcSticky, 50);
    });
    observer.observe(meta, { childList: true, subtree: true, attributes: true });
  }

  /* --- 3. Open first accordion + hide its "Description" header --- */
  function openFirstAccordion() {
    var tabs = document.querySelectorAll('.product-section .product-block--tab');
    if (!tabs.length) return;

    var firstTab = tabs[0];
    var trigger = firstTab.querySelector('.collapsible-trigger');
    var content = firstTab.querySelector('.collapsible-content');

    if (trigger && content) {
      /* Force open */
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      content.classList.add('is-open');
      content.style.height = 'auto';

      /* Hide the "Description" trigger — let the copy speak for itself */
      trigger.style.display = 'none';
    }
  }

  /* --- 4. Neutralize Impulse's product sticky JS ---
     Impulse sets inline style "position:sticky; top:9254px" via
     its own JS. We override with a MutationObserver on the meta
     element's style attribute. */
  function neutralizeImpulseSticky() {
    if (window.innerWidth < 769) return;

    var meta = document.querySelector('.product-section .product-single__meta');
    if (!meta) return;

    var lastKnownTop = meta.style.top;

    var styleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'style') {
          /* If Impulse set a crazy top value (>1000px), fix it */
          var currentTop = parseInt(meta.style.top, 10);
          if (currentTop > 1000 || isNaN(currentTop)) {
            initStickyProductInfo();
          }
        }
      });
    });

    styleObserver.observe(meta, { attributes: true, attributeFilter: ['style'] });
  }

  /* --- 5. Force-load complementary products ---
     Impulse's native <product-recommendations> custom element
     fails to initialize after our Flickity destruction.
     Fetch product data from the JSON API and build simple cards. */
  function loadComplementaryProducts() {
    var el = document.querySelector('product-recommendations[data-intent="complementary"]');
    if (!el) return;

    var productId = el.getAttribute('data-product-id');
    var limit = el.getAttribute('data-limit') || 4;
    if (!productId) return;

    var jsonUrl = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=complementary';

    fetch(jsonUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) return;

        var container = el.querySelector('[data-subsection]');
        if (!container) return;

        var cards = data.products.map(function(p) {
          var imgSrc = p.featured_image ? 'https:' + p.featured_image.replace(/\.([^.]+)$/, '_180x240_crop_center.$1') : '';
          var price = '$' + (p.price / 100).toFixed(2);
          var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
          var imgHtml = imgSrc
            ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" width="60" height="80" loading="eager" style="width:100%;height:100%;object-fit:cover;display:block;">'
            : '';

          return '<div class="pstv-comp-card">'
            + '<a href="' + p.url + '" class="pstv-comp-card__link">'
            + '<div class="pstv-comp-card__img">' + imgHtml + '</div>'
            + '<div class="pstv-comp-card__info">'
            + '<div class="pstv-comp-card__title">' + p.title + '</div>'
            + '<div class="pstv-comp-card__price">' + price + '</div>'
            + '</div></a>'
            + (variantId ? '<button class="pstv-comp-card__atc" data-variant-id="' + variantId + '" aria-label="Add ' + p.title.replace(/"/g, '&quot;') + ' to cart">ADD +</button>' : '')
            + '</div>';
        }).join('');

        /* Build a clean container — bypass Impulse's grid markup entirely.
           Note: HTML is built from Shopify's own JSON API response
           (product titles, prices, CDN image URLs — all store-owned data). */
        var wrapper = document.createElement('div');
        wrapper.className = 'pstv-comp-products';
        wrapper.innerHTML = cards;
        container.replaceWith(wrapper);

        /* ATC click handlers */
        wrapper.querySelectorAll('.pstv-comp-card__atc').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-variant-id');
            if (!vid) return;
            btn.textContent = '...';
            btn.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              btn.textContent = 'ADDED';
              setTimeout(function() { btn.textContent = 'ADD +'; btn.disabled = false; }, 1500);
              /* Open cart drawer if theme supports it */
              if (window.theme && typeof theme.cart === 'object' && typeof theme.cart.getCart === 'function') {
                theme.cart.getCart();
              } else {
                document.dispatchEvent(new CustomEvent('cart:build'));
              }
            })
            .catch(function() { btn.textContent = 'ADD +'; btn.disabled = false; });
          });
        });
      })
      .catch(function() { /* silent */ });
  }

  /* --- 6. Desktop zoom lightbox ---
     Impulse's Photoswipe bindings break after Flickity destruction.
     Re-bind zoom buttons with a simple fullscreen lightbox. */
  function initDesktopZoom() {
    if (window.innerWidth < 769) return;

    var slides = document.querySelectorAll('.product-section .product-main-slide');
    if (!slides.length) return;

    /* Build items array from all product images */
    var items = [];
    slides.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      /* Best source: srcset largest, then currentSrc, then src */
      var src = img.currentSrc || img.src;
      /* Try to get the zoom-size URL from srcset (pick widest) */
      if (img.srcset) {
        var candidates = img.srcset.split(',').map(function(s) {
          var parts = s.trim().split(/\s+/);
          var w = parseInt((parts[1] || '0').replace('w', ''), 10);
          return { url: parts[0], w: w };
        });
        candidates.sort(function(a, b) { return b.w - a.w; });
        if (candidates.length) src = candidates[0].url;
      }
      items.push({ src: src, w: img.naturalWidth || 1800, h: img.naturalHeight || 2400 });
    });

    slides.forEach(function(slide, idx) {
      /* Click on zoom button */
      var zoomBtn = slide.querySelector('.js-photoswipe__zoom');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(idx);
        });
      }
      /* Also open on image click */
      var img = slide.querySelector('img');
      if (img) {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function(e) {
          e.preventDefault();
          openLightbox(idx);
        });
      }
    });

    function openLightbox(startIdx) {
      if (!items[startIdx]) return;

      var overlay = document.createElement('div');
      overlay.className = 'pstv-lightbox';
      var currentIdx = startIdx;
      var zoomed = false;

      function render() {
        zoomed = false;
        overlay.innerHTML = '<div class="pstv-lightbox__close">&times;</div>'
          + '<img src="' + items[currentIdx].src + '" class="pstv-lightbox__img" />'
          + (items.length > 1
            ? '<button class="pstv-lightbox__nav pstv-lightbox__prev" aria-label="Previous">&lsaquo;</button>'
            + '<button class="pstv-lightbox__nav pstv-lightbox__next" aria-label="Next">&rsaquo;</button>'
            : '');

        var img = overlay.querySelector('.pstv-lightbox__img');
        img.style.cursor = 'zoom-in';

        /* Click image to toggle zoom */
        img.addEventListener('click', function(e) {
          e.stopPropagation();
          zoomed = !zoomed;
          if (zoomed) {
            img.classList.add('pstv-lightbox__img--zoomed');
            img.style.cursor = 'zoom-out';
            /* Pan to click position */
            panToPoint(img, e.clientX, e.clientY);
          } else {
            img.classList.remove('pstv-lightbox__img--zoomed');
            img.style.cursor = 'zoom-in';
            img.style.transformOrigin = '';
            img.style.transform = '';
          }
        });

        /* Mouse-move panning when zoomed */
        img.addEventListener('mousemove', function(e) {
          if (!zoomed) return;
          panToPoint(img, e.clientX, e.clientY);
        });
      }

      function panToPoint(img, clientX, clientY) {
        var rect = overlay.getBoundingClientRect();
        var xPct = (clientX - rect.left) / rect.width * 100;
        var yPct = (clientY - rect.top) / rect.height * 100;
        img.style.transformOrigin = xPct + '% ' + yPct + '%';
      }

      render();

      overlay.addEventListener('click', function(e) {
        if (e.target.classList.contains('pstv-lightbox__prev')) {
          currentIdx = (currentIdx - 1 + items.length) % items.length;
          render();
        } else if (e.target.classList.contains('pstv-lightbox__next')) {
          currentIdx = (currentIdx + 1) % items.length;
          render();
        } else if (e.target.classList.contains('pstv-lightbox') || e.target.classList.contains('pstv-lightbox__close')) {
          overlay.remove();
          document.removeEventListener('keydown', onKey);
        }
      });

      function onKey(e) {
        if (e.key === 'Escape') { overlay.remove(); document.removeEventListener('keydown', onKey); }
        if (e.key === 'ArrowLeft') { currentIdx = (currentIdx - 1 + items.length) % items.length; render(); }
        if (e.key === 'ArrowRight') { currentIdx = (currentIdx + 1) % items.length; render(); }
      }
      document.addEventListener('keydown', onKey);
      document.body.appendChild(overlay);
    }
  }

  /* --- Init ---
     Watch for Flickity to add .flickity-enabled to the slideshow,
     then destroy it on the same frame. Eliminates the visible
     "image starts small then pops to full size" reflow gap. */
  function runPostFlickityInit() {
    initStickyProductInfo();
    openFirstAccordion();
    neutralizeImpulseSticky();
    loadComplementaryProducts();
    initDesktopZoom();
    /* Recalc after accordion opens (changes content height) */
    setTimeout(initStickyProductInfo, 200);
  }

  function init() {
    if (window.innerWidth < 769) {
      /* Mobile: Impulse Flickity stays. Just init the rest. */
      runPostFlickityInit();
      return;
    }

    var slideshow = document.querySelector('.product-section .product-slideshow');
    if (!slideshow) {
      runPostFlickityInit();
      return;
    }

    var done = false;
    function killAndContinue() {
      if (done) return;
      done = true;
      destroyFlickity();
      runPostFlickityInit();
    }

    /* If Flickity already enabled by the time we run, kill immediately. */
    if (slideshow.classList.contains('flickity-enabled')) {
      killAndContinue();
      return;
    }

    /* Otherwise watch for the class addition and kill on the same frame. */
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (slideshow.classList.contains('flickity-enabled')) {
          observer.disconnect();
          killAndContinue();
          return;
        }
      }
    });
    observer.observe(slideshow, { attributes: true, attributeFilter: ['class'] });

    /* Safety net: if Flickity never initializes (single-image PDP, etc.),
       still run the rest of the init after 600ms. */
    setTimeout(function() {
      observer.disconnect();
      killAndContinue();
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
